<template>
  <main-layout>
    <game-frame/>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/Main.vue';
import GameFrame from '@/components/game/Frame.vue';

export default {
  components: {
    MainLayout,
    GameFrame,
  },
};
</script>

<style>
html,
body {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Index.vue